// actions
export var GET_GROUP_LIST = 'GET_GROUP_LIST'; // mutations

export var MUTATE_GROUP_LIST = 'MUTATE_GROUP_LIST';
export var MUTATE_GROUP_PAGING = 'MUTATE_GROUP_PAGING'; // getters

export var GETTER_GROUP_LIST = 'GETTER_GROUP_LIST';
export var GETTER_GROUP_PAGING = 'GETTER_GROUP_PAGING';